module.exports = __webpack_public_path__ + "img/director-test-icon3.e105b7fc.png";